import { PropsWithChildren, useCallback, useState } from 'react';

import { Button, ButtonProps, ButtonSizes, ButtonVariant, Icon, IconName } from '@/shared/ui';

export interface ActionButtonProps extends PropsWithChildren {
  buttonVariant?: ButtonProps['variant'];
  size?: ButtonSizes;
  disabled?: boolean;
  iconName: Nullable<IconName>;
  onClick: () => Promise<void>;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  buttonVariant = ButtonVariant.GHOST,
  size = ButtonSizes.SM,
  disabled = false,
  children,
  onClick,
  iconName,
}) => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const handleClick = useCallback(() => {
    setLoading(true);
    onClick().finally(() => setLoading(false));
  }, [onClick]);

  return (
    <Button size={size} variant={buttonVariant} disabled={disabled || isLoading} onClick={handleClick}>
      {iconName && <Icon name={iconName} />}
      {children}
    </Button>
  );
};
